import { render } from "./sandTab.vue?vue&type=template&id=24a9d5b4&scoped=true"
import script from "./sandTab.vue?vue&type=script&lang=js"
export * from "./sandTab.vue?vue&type=script&lang=js"

import "./sandTab.vue?vue&type=style&index=0&id=24a9d5b4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a9d5b4"]])

export default __exports__